// src/ContactUs.jsx
import React from "react";
import Form from "./components/layout/Form"; // Ensure this path is correct

const ContactUs = () => {
  return (
    <div>
      <br />
      <br />
      <Form /> {/* This will render the Form component */}
    </div>
  );
};

export default ContactUs;
